import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    copyLoading: (count: number) => string;
    copyErrorMessage: string;
    copySuccessMessage: (count: number) => string;
    duplicateLoading: (count: number) => string;
    duplicateErrorMessage: string;
    duplicateSuccessMessage: (count: number) => string;
    adobeDuplicateSuccessMessage: (count: number) => string;
    adobeCopySuccessMessage: (count: number) => string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            copyLoading: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number): string => __intl__.intl().formatMessage({ id: "useSyncCopyAssets.copyLoading?c=3d7sc6e8m91cb", defaultMessage: "{count, plural, one {Copying 1 item\u2026} other {Copying {count} items\u2026}}" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            },
            copyErrorMessage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useSyncCopyAssets.copyErrorMessage?c=1zzg39u844pqh", defaultMessage: "Your items could not be copied" }));
                },
                enumerable: true,
                configurable: true
            },
            copySuccessMessage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number): string => __intl__.intl().formatMessage({ id: "useSyncCopyAssets.copySuccessMessage?c=fmzzppi3kgq5", defaultMessage: "{count, plural, one {Copied 1 item} other {Copied {count} items}}" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            },
            duplicateLoading: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number): string => __intl__.intl().formatMessage({ id: "useSyncCopyAssets.duplicateLoading?c=2us7kichgl5ok", defaultMessage: "{count, plural, one {Duplicating 1 item\u2026} other {Duplicating {count} items\u2026}}" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            },
            duplicateErrorMessage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useSyncCopyAssets.duplicateErrorMessage?c=389c7fnukxzw7", defaultMessage: "Your items could not be duplicated" }));
                },
                enumerable: true,
                configurable: true
            },
            duplicateSuccessMessage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number): string => __intl__.intl().formatMessage({ id: "useSyncCopyAssets.duplicateSuccessMessage?c=33vdnvy4tbdeo", defaultMessage: "{count, plural, one {Duplicated 1 item} other {Duplicated {count} items}}" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            },
            adobeDuplicateSuccessMessage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number): string => __intl__.intl().formatMessage({ id: "useSyncCopyAssets.adobeDuplicateSuccessMessage?c=zs2tcvy15yal", defaultMessage: "{count, plural, one {1 Item(s) duplicated} other {{count} Item(s) duplicated}}" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            },
            adobeCopySuccessMessage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number): string => __intl__.intl().formatMessage({ id: "useSyncCopyAssets.adobeCopySuccessMessage?c=3u5291m2xqnhr", defaultMessage: "{count, plural, one {1 Item(s) copied} other {{count} Item(s) copied}}" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
